///////////////////////////////////////
//            轉場href判斷           //
///////////////////////////////////////

$('a:not(.nocg)').click(function(e) {
    e.preventDefault();
    var thisTarget = $(this).attr("target");
    var aHref = $(this).attr("href");
    // 本地
    var x = window.location.pathname.replace("http://","")
    var xArr = x.split("/");
        xArr = lastArr(xArr)
    // 連結
    var href = $(this).attr("href");
    var y = this.href.replace("http://","")
    var yArr = y.split("/");
        yArr = lastArr(yArr);
    function lastArr(arr) {
        var last = arr.pop()
        if (last.indexOf("#") > -1) {
            arr.push(last)
        } else if (last.indexOf("html") > 0) {
            arr.push(last)
        } else if (last == "") {
            arr.push('index.html')
        } else {
            arr.push(last)
            arr.push('index.html')
        }
        return arr
    }
    if (thisTarget == "_blank" || e.ctrlKey||e.metaKey) {
        window.open(aHref);
    } else if (y.indexOf('jpg') > -1 || y.indexOf('javascript') > -1) {
        //啥事都不幹
    } else if (xArr.length == yArr.length && xArr[xArr.length - 1] == yArr[yArr.length - 1] && xArr[xArr.length - 2] == yArr[yArr.length - 2] && xArr[xArr.length - 3] == yArr[yArr.length - 3]) {
        //自己那頁 啥事都不幹
    } else {
        randonAnimte(href);
    }
})


function randonAnimte(href){
    var i = Math.floor(Math.random() * Math.floor(4)) + 1;
    switch (1) {
        case 1:
            pagechange.CG_A(href)
            break;
        case 2:
            pagechange.CG_B(href)
            break;
        case 3:
            pagechange.CG_C(href)
            break;
        case 4:
            pagechange.CG_D(href)
            break;
        default:
            break;
    }
}


var pagechange = {
    CG_A: function(href) {
        $("html,body").delay(100).animate({ opacity: "0" }, {
            queue: true,
            duration: 800,
            easing: "easeOutQuad",
            complete: function() {
                window.location.assign(href);
            }
        });
    },
    CG_B: function(href) {
        $("main").append("<div id='CG_Abg'><div class='CG_Abg1'></div><div class='CG_Abg2'></div></div>");

        $("body").delay(1200).animate({ opacity: "0" }, {
            queue: true,
            duration: 200,
            easing: "easeOutQuad",
            complete: function() {
                setTimeout(function() {
                    window.location.assign(href);
                }, 100);
            } 
        }); 
    }, 
    CG_C: function(href) {
        $("main").append("<div id='CG_Bbg'></div>");
        $("body").delay(1200).animate({ opacity: "0" }, {
            queue: true,
            duration: 200,
            easing: "easeOutQuad",
            complete: function() {
                setTimeout(function() {
                    window.location.assign(href);
                }, 100);
            } 
        }); 
    }, 
    CG_D: function(href) {
        $("main").append("<div id='CG_Cbg'><div class='CG_Cbg1'></div><div class='CG_Cbg2'></div></div>");
        $("body").delay(1200).animate({ opacity: "0" }, {
            queue: true,
            duration: 200,
            easing: "easeOutQuad",
            complete: function() {
                setTimeout(function() {
                    window.location.assign(href);
                }, 100);
            } 
        });
    } 
}

//動態曲線
jQuery.easing['jswing'] = jQuery.easing['swing'];
jQuery.extend(jQuery.easing, {
    def: 'easeOutQuad',

    easeOutQuad: function(x, t, b, c, d) {
        return -c * (t /= d) * (t - 2) + b;
    },
    easeInOutCirc: function(x, t, b, c, d) {
        if ((t /= d / 2) < 1) return -c / 2 * (Math.sqrt(1 - t * t) - 1) + b;
        return c / 2 * (Math.sqrt(1 - (t -= 2) * t) + 1) + b;
    },
});

const svgg = `
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 348.97 118"><rect class="cls-1" x="0.76" y="21.21" width="347.97" height="65.28"/><polygon class="cls-2" points="131.46 49.34 108.89 49.34 108.89 26.76 99.62 26.78 99.63 49.35 77.08 49.37 77.06 58.59 99.64 58.59 99.62 81.17 108.89 81.15 108.89 58.61 131.44 58.59 131.46 49.34"/><path class="cls-3" d="M52.93,13.89H42.16L0,118l14.68,0S24.85,92.67,27.05,87.34c5.74,0,34.43-.06,40.14,0C69.38,92.71,79.49,118,79.49,118l14.57,0ZM32.49,73.82c3.37-8.5,9.86-24.67,14.94-37.37,5,12.77,11.23,29,14.47,37.37Z"/><path class="cls-4" d="M220.67,36.22a19,19,0,0,0-3.51-7.62,17.16,17.16,0,0,0-6.57-5.07,23.71,23.71,0,0,0-9.81-1.8A21.72,21.72,0,0,0,187.52,26a19.87,19.87,0,0,0-5.58,6.82,18.38,18.38,0,0,0-5.16-7.06,19.27,19.27,0,0,0-13-4h0a20.3,20.3,0,0,0-7.2,1.38l-6.18,3.77s-2.35,2.71-3.68,4.35c0-2.93,0-8.11,0-8.11l-6.4,0,0,63.51,6.42,0L146.72,51A33.82,33.82,0,0,1,148,42.06a22.64,22.64,0,0,1,3.47-7.3,16.89,16.89,0,0,1,5.44-4.84,13.86,13.86,0,0,1,7-1.79,15.59,15.59,0,0,1,7.16,1.43,9.84,9.84,0,0,1,4,3.66,15.54,15.54,0,0,1,2.11,5.72l.6,7.51,0,40.21,6.36-.06V46.89a22.42,22.42,0,0,1,1.15-7.22,18.14,18.14,0,0,1,3.36-6,15.09,15.09,0,0,1,5.18-4.05,16.18,16.18,0,0,1,6.88-1.48A18.25,18.25,0,0,1,208,29.37a10,10,0,0,1,4.21,3.3,12.66,12.66,0,0,1,2.31,5.26l.7,7.6V86.64h6.4V45.53Z"/><path class="cls-4" d="M281.67,42.66a31.52,31.52,0,0,0-5-10.64,25.57,25.57,0,0,0-8.91-7.59,27,27,0,0,0-12.9-2.85,25.21,25.21,0,0,0-10.54,2.22,25.82,25.82,0,0,0-9,6.51,31.65,31.65,0,0,0-6.14,10.35,36.5,36.5,0,0,0-2.35,13.72,49,49,0,0,0,1.56,12.73,32,32,0,0,0,4.91,10.57,23.36,23.36,0,0,0,8.86,7.08,28.46,28.46,0,0,0,12.74,2.34c7.23,0,13.36-2,18.37-6.12s8-9.85,8.95-17.29l.3-2.25-6.41,0-.27,1.73c-.93,6-3.23,10.41-6.92,13.28s-8.56,4.46-14.27,4.47a22.22,22.22,0,0,1-9.87-2,18.16,18.16,0,0,1-6.45-5.31,24.59,24.59,0,0,1-3.73-8.2h0a44.37,44.37,0,0,1-1.11-8.52c4.2,0,49.38,0,49.38,0l.06-2c0-.57,0-1.14,0-1.74A43,43,0,0,0,281.67,42.66Zm-5.44,7.88H233.62a35.17,35.17,0,0,1,1.73-8.35,27,27,0,0,1,4.76-7.8,20.6,20.6,0,0,1,6.71-4.86,21.9,21.9,0,0,1,8.27-1.65,21,21,0,0,1,9.28,1.95A18.78,18.78,0,0,1,271,35a24,24,0,0,1,4.09,7.87A31.46,31.46,0,0,1,276.23,50.54Z"/><path class="cls-4" d="M338.68,0l-4.34,0s0,22,0,32.6a25.61,25.61,0,0,0-5.09-5.69c-4.44-3.52-10.09-5.39-16.91-5.4a24.72,24.72,0,0,0-20.39,10.14,34.36,34.36,0,0,0-5.22,10.47,45.44,45.44,0,0,0,.09,25.22,31.69,31.69,0,0,0,5.38,10.37,26.63,26.63,0,0,0,8.67,6.91,26.15,26.15,0,0,0,11.47,2.47c6.51,0,12.17-1.79,16.59-5.38a26.76,26.76,0,0,0,5.45-5.89c0,4,0,10,0,10l6.36,0V0ZM328.44,73.21a20.67,20.67,0,0,1-6.85,5.63,20.29,20.29,0,0,1-9.31,2.06,19.7,19.7,0,0,1-9.18-2.09,18,18,0,0,1-6.4-5.6,27.33,27.33,0,0,1-4-8.47,36.47,36.47,0,0,1-1.41-10.22,39.46,39.46,0,0,1,1.31-9.75,27.13,27.13,0,0,1,3.83-8.55,20.46,20.46,0,0,1,6.49-6,19.52,19.52,0,0,1,9.36-2.31c6.66,0,11.91,2.24,15.91,6.74s6.09,11.16,6.1,19.89a34.66,34.66,0,0,1-1.51,10.25A27,27,0,0,1,328.44,73.21Z"/><path class="cls-5" d="M103.38,108.25c-2.76-.1-5.88.51-5.89,3.7,0,2,1.09,2.89,2.38,2.92a3.72,3.72,0,0,0,3.41-2.84,3.36,3.36,0,0,0,.08-.93Zm2.43,4.43c0,1.48,0,2.95.2,4H103.8l-.25-2.09-.1,0a4.77,4.77,0,0,1-4.21,2.42c-2.77,0-4.23-2.35-4.23-4.76,0-4,2.95-6.16,8.3-6.15v-.32c0-1.36-.32-3.89-3.13-3.88a6.14,6.14,0,0,0-3.64,1.26l-.56-2a8,8,0,0,1,4.56-1.49c4.25,0,5.29,3.52,5.3,6.84Z"/><path class="cls-5" d="M119.28,106.87a8.15,8.15,0,0,0-.11-1.3,3.93,3.93,0,0,0-3.63-3.45c-2.59,0-4.16,2.73-4.17,6.33,0,3.45,1.41,6.19,4.09,6.18,1.69,0,3.23-1.34,3.69-3.59a6,6,0,0,0,.13-1.28Zm2.49-14.5v20c0,1.5,0,3.13.16,4.28l-2.28,0-.12-2.9,0,0a5.14,5.14,0,0,1-4.68,3.31c-3.31,0-5.94-3.43-5.92-8.44-.09-5.58,2.85-9,6.21-8.92a4.43,4.43,0,0,1,4.15,2.51l.06,0,0-9.87Z"/><path class="cls-5" d="M127,100.14l2.67,9.29c.48,1.53.82,2.89,1.14,4.28l.05,0c.32-1.37.69-2.7,1.21-4.28l2.63-9.32,2.68.06-5.47,16.55h-2.4l-5.21-16.54Z"/><path class="cls-5" d="M146.57,108.25c-2.79-.09-5.87.51-5.87,3.74,0,2,1.1,2.88,2.36,2.87a3.58,3.58,0,0,0,3.38-2.79,2.84,2.84,0,0,0,.15-1Zm2.43,4.48a31.47,31.47,0,0,0,.21,4l-2.27,0-.22-2.11-.08,0a4.75,4.75,0,0,1-4.24,2.48c-2.78.07-4.18-2.32-4.24-4.75,0-4,3-6.18,8.33-6.16l0-.35c0-1.38-.34-3.87-3.17-3.86a6.05,6.05,0,0,0-3.62,1.25l-.58-2a7.87,7.87,0,0,1,4.6-1.41c4.25,0,5.24,3.45,5.25,6.75Z"/><path class="cls-5" d="M153,104.61c0-1.77,0-3.12-.13-4.54l2.26,0,.09,2.7h.06a5.11,5.11,0,0,1,4.61-3.06c1.89,0,4.87,1.35,4.86,7v9.95h-2.51v-9.57c0-2.7-.87-5-3.23-5-1.61,0-2.9,1.4-3.36,3.11a4.57,4.57,0,0,0-.11,1.38l-.08,10H153Z"/><path class="cls-5" d="M178.72,116.16a8.93,8.93,0,0,1-4,.93c-4.14,0-6.84-3.39-6.85-8.51s2.89-8.83,7.4-8.87a7.14,7.14,0,0,1,3.5.92l-.56,2.29a5.12,5.12,0,0,0-2.95-.76c-3.16,0-4.83,2.83-4.83,6.28,0,3.84,2,6.21,4.77,6.2a5.83,5.83,0,0,0,3.08-.78Z"/><path class="cls-5" d="M190.3,106.79c0-1.9-.65-4.91-3.48-4.91-2.55,0-3.63,2.8-3.87,4.9Zm-7.36,2.11c.08,4.07,2.19,5.77,4.72,5.77a8.21,8.21,0,0,0,3.86-.82l.42,2.11a9.78,9.78,0,0,1-4.66,1.13c-4.2-.06-6.78-3.41-6.77-8.38s2.48-9,6.5-9c4.56,0,5.71,4.84,5.69,7.87a7.72,7.72,0,0,1-.07,1.42Z"/><path class="cls-5" d="M205.21,106.85a4.74,4.74,0,0,0-.07-1.3c-.41-1.88-1.74-3.45-3.66-3.44-2.55,0-4.12,2.74-4.12,6.35,0,3.42,1.4,6.21,4.08,6.21,1.71,0,3.23-1.36,3.65-3.63a3.55,3.55,0,0,0,.14-1.32Zm2.56-14.45,0,20c0,1.45,0,3.14.1,4.28l-2.23,0-.09-2.88h-.1a5,5,0,0,1-4.67,3.25c-3.36,0-5.91-3.41-5.91-8.43,0-5.54,2.8-8.92,6.17-8.91a4.36,4.36,0,0,1,4.14,2.5h.1l0-9.87Z"/><path class="cls-5" d="M218,104.6c0-1.71,0-3.12-.11-4.49h2.19l.1,2.69h.09a4.74,4.74,0,0,1,4.4-3.05c1.81,0,3.27,1.33,3.88,3.34h0a7.43,7.43,0,0,1,1.59-2.2,4.32,4.32,0,0,1,3-1.16c1.88,0,4.61,1.49,4.61,7.21v9.77l-2.42,0-.05-9.41c0-3.25-.95-5.13-3-5.12-1.44,0-2.53,1.27-3,2.72a5.38,5.38,0,0,0-.21,1.55l0,10.26-2.5,0v-9.87c0-2.7-1-4.63-2.9-4.58-1.49,0-2.7,1.47-3.13,3a4.62,4.62,0,0,0-.17,1.45v10l-2.43,0Z"/><path class="cls-5" d="M250.57,106.82c.05-1.91-.7-5-3.44-4.94-2.59,0-3.64,2.75-3.87,4.85Zm-7.35,2.07c.07,4.08,2.22,5.77,4.74,5.77a8.28,8.28,0,0,0,3.78-.8l.47,2.1a9.22,9.22,0,0,1-4.59,1.09c-4.24,0-6.82-3.41-6.82-8.36s2.49-9,6.51-9c4.51-.06,5.65,4.77,5.71,7.82a11.18,11.18,0,0,1-.14,1.42Z"/><path class="cls-5" d="M265.54,106.85a7.07,7.07,0,0,0-.14-1.29c-.36-1.87-1.73-3.47-3.57-3.45-2.62,0-4.19,2.74-4.13,6.4-.06,3.39,1.35,6.16,4.05,6.14,1.69,0,3.19-1.36,3.68-3.59a9.28,9.28,0,0,0,.08-1.34Zm2.51-14.51,0,20.08c.05,1.49,0,3.13.15,4.27h-2.25l-.12-2.87h-.06a5.11,5.11,0,0,1-4.7,3.27c-3.31,0-5.94-3.41-5.89-8.44-.07-5.59,2.84-8.94,6.18-8.91a4.41,4.41,0,0,1,4.14,2.47l.05,0,0-9.88Z"/><path class="cls-5" d="M272.21,100.11h2.53v16.58h-2.51ZM273.42,97c-.95,0-1.59-.84-1.62-1.93a1.8,1.8,0,0,1,1.67-1.93,1.77,1.77,0,0,1,1.6,2,1.7,1.7,0,0,1-1.6,1.92Z"/><path class="cls-5" d="M288.74,116.12a9.11,9.11,0,0,1-3.91,1c-4.23,0-6.93-3.44-6.93-8.52s2.9-8.87,7.42-8.82a6.4,6.4,0,0,1,3.48.89l-.55,2.3a5,5,0,0,0-2.91-.82c-3.18,0-4.89,2.87-4.89,6.33,0,3.82,2.06,6.22,4.8,6.22a6.46,6.46,0,0,0,3.08-.8Z"/><path class="cls-5" d="M299,108.26c-2.77-.08-5.92.47-5.87,3.69,0,2,1,2.87,2.34,2.9a3.6,3.6,0,0,0,3.39-2.78,2.23,2.23,0,0,0,.09-1Zm2.45,4.46c0,1.42.07,2.84.17,4H299.4l-.22-2.08-.08,0a5,5,0,0,1-4.24,2.48c-2.81,0-4.22-2.37-4.23-4.76,0-4,2.95-6.21,8.32-6.16l-.06-.35c0-1.39-.28-3.87-3-3.81a5.59,5.59,0,0,0-3.64,1.23l-.59-2a7.71,7.71,0,0,1,4.54-1.46c4.31,0,5.32,3.46,5.32,6.8Z"/><path class="cls-5" d="M308.39,96.14l0,4,3.61,0,0,2.29H308.4l0,8.92c0,2.09.53,3.25,1.92,3.25a3.38,3.38,0,0,0,1.47-.25l.1,2.33a5.84,5.84,0,0,1-2.22.39A3.06,3.06,0,0,1,307,115.8a7.27,7.27,0,0,1-1-4.36v-9l-2.13,0,0-2.31,2.09,0,0-3.06Z"/><path class="cls-5" d="M314.81,100.05l2.54.07,0,16.53-2.49,0Zm1.18-3a1.82,1.82,0,0,1-1.55-1.94,1.77,1.77,0,0,1,1.64-1.92c1,0,1.6.84,1.59,1.93A1.75,1.75,0,0,1,316,97Z"/><path class="cls-5" d="M327.2,114.79c2.45,0,4.23-2.7,4.23-6.42,0-2.85-1.19-6.4-4.16-6.4s-4.19,3.3-4.21,6.48c0,3.62,1.72,6.37,4.14,6.34Zm-.05,2.3c-3.73,0-6.63-3.29-6.65-8.54,0-5.54,3.07-8.8,6.85-8.79,4,0,6.68,3.43,6.67,8.45,0,6.2-3.56,8.9-6.82,8.88Z"/><path class="cls-5" d="M337.17,104.59c0-1.75,0-3.11-.08-4.48h2.21l.14,2.76.05,0a5.12,5.12,0,0,1,4.57-3.07c1.92,0,4.88,1.36,4.91,7v10l-2.5,0v-9.58c0-2.67-.87-4.93-3.23-4.92a3.8,3.8,0,0,0-3.34,3.1,3.69,3.69,0,0,0-.19,1.38v10l-2.5,0Z"/></svg>
`

// 進場
var transStart = {
  // 啟用轉場單元
  active: function() {
    let page = $('body').attr('data-trans');
    let storage = sessionStorage.getItem('trans');
    if( !sessionStorage.hasOwnProperty("trans") ) {
      if(page === 'home') transStart.transIn1();
      else if (page === 'unit') transStart.transIn2();
      sessionStorage.setItem('trans', 'true');
    }
  },
  transIn1: function() {
    $('body').append(
      `
        <div class="t-container in">
          <div class="t-wrap home">
            <div class="text">A
              <div class="mix box1"></div>
            </div>
            <div class="text">M
              <div class="mix box2"></div>
            </div>
            <div class="text">E
              <div class="mix box3"></div>
            </div>
            <div class="text">D
              <div class="mix box4"></div>
            </div>
            <div class="clip clip1">
              ${svgg}
            </div>
          </div>
        </div>
      `
    );

    setTimeout(function(){
      $('.t-container').addClass('out')
    },1900)

    setTimeout(function(){
      $('.t-container').remove();
    },2200)
  },
  transIn2: function() {
    $('body').append(
      `
        <div class="t-container in">
          <div class="t-wrap unit">
            <div class="clip clip2">
              ${svgg}
            </div>
          </div>
        </div>
      `
    )

    setTimeout(function(){
      $('.t-container').addClass('out')
    },1400)

    setTimeout(function(){
      $('.t-container').remove();
    },1800)
  }
}

transStart.active();
